import { Component, OnInit, OnDestroy, Input, inject } from "@angular/core";

import { AlertService, MessageSeverity, DialogType } from '../../../services/alert.service';
import { AuthService } from "../../../services/auth.service";
import { ConfigurationService } from '../../../services/configuration.service';
import { Utilities } from '../../../services/utilities';
import { UserLogin } from '../../../models/user-login.model';
import { AccountService } from "../../../services/account.service";
import { Router, RouterLink, RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { Roles, RoleTypes } from '../../../models/enums';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
  ]
})
export class LoginComponent implements OnInit {


  userLogin = new UserLogin();
  isLoading = false;
  loginStatusSubscription: any;
  formResetToggle = true;

  //@Input() isModal = false;
  @Input() isSessionExpired = false;

  constructor(
    private alertService: AlertService, 
    private authService: AuthService, 
    private configurations: ConfigurationService, 
    private accountService: AccountService,
    private router: Router
  ) {

  }

  ngOnInit() {

     this.userLogin.rememberMe = this.authService.rememberMe;
      
  }


  ngOnDestroy() {
    if (this.loginStatusSubscription)
      this.loginStatusSubscription.unsubscribe();
  }

  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }



  login() {
    this.isLoading = true;
    this.alertService.startLoadingMessage("", "Attempting login...");
    this.authService.login(this.userLogin.email, this.userLogin.password, this.userLogin.rememberMe)
      .subscribe({
        next: (user: any) => {
          setTimeout(() => {
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
         
            let fullName = this.authService.currentUser?.fullName;

            if (!this.isSessionExpired) {
              console.log('session active ')
              this.alertService.showMessage("Login", `Welcome, ${fullName}!`, MessageSeverity.success);
            }
            else {
              console.log('session restored')
              this.alertService.showMessage("Login", `Session for ${user.userName} restored!`, MessageSeverity.success);
            }


            //if (this.accountService.GetActiveProject() != null && this.accountService.GetActiveRole() != null) {
            //  this.accountService.GetCurrentUserTeamsObservable().subscribe({
            //    next: (success) => {
            //      console.log("Successfully queried user teams");
            //    }, error: (error) => {
            //      console.log(error)
            //      this.alertService.showMessage("Login", "Failed to query teams for user!", MessageSeverity.error);
            //    }, complete: () => {
            //      this.authService.redirectLoginUser();
            //    }
            //  });
            //}

            /// check for users with only one each of role/project/team - if so:
            /// 1) set each as active
            /// 2) authService.redirectLoginUser() will skip role/project/team selection page and send to home

            ///var currentUserRoles = user.roles;
            var currentUserRoles = this.accountService.GetCurrentUserRoleIDs();
            var currentUserProjects = this.accountService.GetCurrentUserProjects();
            var currentUserTeams = this.accountService.GetCurrentUserTeams();

            /// if user has one role, set as active and get projects
            /*if (user.roles.length == 1) {*/
            if (currentUserRoles.length == 1) {              
              this.accountService.SetActiveRole(+currentUserRoles[0]);
              var activeRoleId = this.accountService.GetActiveRole();
              this.accountService.GetCurrentUserProjectsObservable(activeRoleId).subscribe({
                next: (success) => {
                  currentUserProjects = this.accountService.GetCurrentUserProjects();
                  /// if user has one project, set as active and get teams
                  if (currentUserProjects.length == 1) {
                    this.accountService.SetActiveProject(currentUserProjects[0]);
                    this.accountService.GetCurrentUserTeamsObservable(activeRoleId, this.accountService.GetActiveProject()).subscribe({
                      next: success => {
                        currentUserTeams = this.accountService.GetCurrentUserTeams();
                        /// if user is a supervisor and has no teams, set active team to null and set all active values selected
                        if (currentUserTeams.length == 0 && (this.accountService.GetActiveRole() == Roles.QCSupervisor || this.accountService.GetActiveRole() == Roles.ReconciliationSupervisor)) {
                          this.accountService.SetActiveTeam(null);
                          this.accountService.SetActiveValsSelected(true);
                          this.authService.redirectLoginUser();
                        } else
                        /// if user has one team, set as active and set all active values selected
                        if (currentUserTeams.length == 1) {
                          this.accountService.SetActiveTeam(currentUserTeams[0]);
                          this.accountService.SetActiveValsSelected(true);
                          this.authService.redirectLoginUser();
                        }
                        else {
                          /// if user has > 1 team, authService.redirectLoginUser() will send to role/project/team selection page
                          this.authService.redirectLoginUser();
                        }
                      },
                      error: (error) => {
                        console.log("Failed to poll current user teams.");
                        console.log(error)
                      }
                    });
                  } else {
                    /// if user has > 1 project, authService.redirectLoginUser() will send to role/project/team selection page
                    this.authService.redirectLoginUser();
                  }
                }, error: (error) => {
                  console.log("Failed to poll current user projects.");
                  console.log(error)
                //}, complete: () => {
                //  this.authService.redirectLoginUser();
                }
              });
            }
            else {
              /// if user has > 1 role, authService.redirectLoginUser() will send to role/project/team selection page
              this.authService.redirectLoginUser();
            }
          }, 500);
        }, error: (error) => {
          console.log(error)

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
          }
                else {
            let errorMessage = Utilities.findHttpResponseMessage("error_description", error);

            if (errorMessage)
              this.alertService.showStickyMessage("Unable to login", errorMessage, MessageSeverity.error, error);
            /*[Notes:BJL_2023-06-24] .NET EF6 Update:
            * - Login error messages were not being returned correctly - "error_description" attribute (in "if" above) did not exist, and "Utilities.getResponseBody(error)" (originally in "else", below) only returned an object.
            * - I added new statments to "else {}" to reference "errorDescription" if available, which returns a meaningful value, and commented the original statement.
            * */
            else {
              let errMsg = "An error occured while logging in, please try again.";
              let errorDesc = Utilities.findHttpResponseMessage("errorDescription", error);
              if (errorDesc) {
                errMsg += "\n\n" + errorDesc;
              }
              this.alertService.showStickyMessage("Unable to login", errMsg, MessageSeverity.error, error);
              //this.alertService.showStickyMessage("Unable to login", "An error occured while logging in, please try again later.\nError: " + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
      }
    });
  }
}
